import { merge } from 'lodash';
var Model = (function () {
    function Model(data, client) {
        var _this = this;
        this.data = data;
        this.client = client;
        this.lastUpdatedAt = Date.now();
        var _loop_1 = function (key) {
            if (this_1.data.hasOwnProperty(key)) {
                Object.defineProperty(this_1, key, {
                    get: function () { return _this.data[key]; },
                    set: function (value) {
                        _this.data[key] = value;
                        _this.lastUpdatedAt = Date.now();
                    },
                });
            }
        };
        var this_1 = this;
        for (var key in this.data) {
            _loop_1(key);
        }
    }
    Model.prototype.createSelf = function (updates) {
        var data = merge({}, this.data, updates);
        return new this.constructor(data, this.client);
    };
    return Model;
}());
export default Model;
//# sourceMappingURL=model.js.map